/**
 * Cliente API de roles de persona (Sprint 12 S12-05, consume
 * endpoints de S11-V2-12).
 *
 * - GET /personas/{id}/roles → lista historica de roles (vigentes + revocados).
 * - POST /personas/{id}/roles → asignar rol.
 * - DELETE /personas/{id}/roles/{rol} → revocar rol vigente.
 *
 * Prerequisitos doctrinarios (convencion #14): el backend rechaza con
 * 422 si se intenta asignar `tesorero` sin `comision`
 * vigentes, etc. El frontend muestra el `detail` retornado.
 */
import { apiFetch } from './client';
import type {
  AsignarRolInput,
  PersonaRolRead,
  RevocarRolInput,
} from './types';

export function listarRolesPersona(personaId: string): Promise<PersonaRolRead[]> {
  return apiFetch<PersonaRolRead[]>(`/personas/${personaId}/roles`);
}

export function asignarRolPersona(
  personaId: string,
  data: AsignarRolInput,
): Promise<PersonaRolRead> {
  return apiFetch<PersonaRolRead>(`/personas/${personaId}/roles`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function revocarRolPersona(
  personaId: string,
  rol: string,
  data: RevocarRolInput = {},
): Promise<PersonaRolRead | null> {
  return apiFetch<PersonaRolRead | null>(
    `/personas/${personaId}/roles/${encodeURIComponent(rol)}`,
    {
      method: 'DELETE',
      body: JSON.stringify(data),
    },
  );
}
